'use es6';

import { blockListAttributes, blockListEditorAttributes, cosElementId, hsSanitizeAllow } from '../../../constants/hscore';
import { addPreProcessTransform, addPostProcessTransform } from '../../../utils/transformer';
import { forEachNode } from 'rich-text-lib/utils/dom';
const getTransformOut = dom => {
  blockListAttributes.forEach(attribute => {
    const nodes = [...dom.body.querySelectorAll(`[${attribute}]`)];
    nodes.forEach(node => {
      node.removeAttribute(attribute);
    });
  });

  // Remove all [data-floating-ui-focus-guard] nodes,
  // which are left over spans from floating-ui elements
  forEachNode(node => {
    node.remove();
  }, dom.querySelectorAll('span[data-floating-ui-focus-guard]'));
};
const filterCosElements = dom => {
  forEachNode(node => {
    if (node.closest(`[${hsSanitizeAllow}]`)) {
      return;
    }
    while (node.firstChild) {
      node.parentNode.insertBefore(node.firstChild, node);
    }
    node.parentNode.removeChild(node);
  }, dom.querySelectorAll(`[id*='${cosElementId}'] `));
};
const filterEditorAttributes = dom => {
  const query = `[${blockListEditorAttributes.join('],[')}]`;
  forEachNode(node => {
    blockListEditorAttributes.forEach(attribute => {
      if (node.hasAttribute(attribute)) {
        node.removeAttribute(attribute);
      }
    });
  }, dom.querySelectorAll(query));
};
export default function initSanitizePlugin(editor) {
  addPostProcessTransform(editor, getTransformOut);
  if (!editor.settings.useModuleInsertion) {
    // don't remove hubl modules if dnd mode is enabled.
    addPreProcessTransform(editor, filterCosElements);
  }
  addPreProcessTransform(editor, filterEditorAttributes);
}